import React, { Component } from "react";
import { Fade } from "react-reveal";
import Button from "../../components/button/Button";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import { skills } from "../../portfolio";
import "./Skills.css";
// import DataScienceImg from "./DataScienceImg";
// import FullStackImg from "./FullStackImg";
// import CloudInfraImg from "./CloudInfraImg";
// import DesignImg from "./DesignImg";

// function GetSkillSvg(props) {
//   if (props.fileName === "DataScienceImg")
//     return <DataScienceImg theme={props.theme} />;
//   else if (props.fileName === "FullStackImg")
//     return <FullStackImg theme={props.theme} />;
//   else if (props.fileName === "CloudInfraImg")
//     return <CloudInfraImg theme={props.theme} />;
//   return <DesignImg theme={props.theme} />;
// }

class SkillSection extends Component {
  render() {
    const theme = this.props.theme;

    return (
      <div>
        {skills.data.map((skill, i) => {
          return (
            <div key={i} className="skills-main-div">
              <Fade left duration={2000}>
                <div className="skills-image-div">
                  {/* <img
                    alt="Ashutosh is Analysing Data"
                    src={require(`../../assets/images/${skill.imagePath}`)}
                  ></img> */}
                  {/* <GetSkillSvg fileName={skill.fileName} theme={theme} /> */}
                  {skill.assetSources.map((asset, i) => {
                    return (
                      <div key={i}>
                        <img
                          className="project-asset-img"
                          alt={asset}
                          src={require(`../../assets/projects/${asset}`)}
                        />
                      </div>
                    );
                  })}
                </div>
              </Fade>

              <div className="skills-text-div">
                <Fade right duration={1000}>
                  <h1 className="skills-heading" style={{ color: theme.text }}>
                    {skill.title}
                  </h1>
                  <h3
                    className="skills-subheading"
                    style={{ color: theme.secondaryText }}
                  >
                    {skill.subtitle}
                  </h3>
                </Fade>
                <Fade right duration={1500}>
                  <SoftwareSkill logos={skill.softwareSkills} />
                </Fade>
                <Fade right duration={2000}>
                  <div>
                    {skill.skills.map((skillSentence, i) => {
                      return (
                        <p
                          key={i}
                          className="subTitle skills-text"
                          style={{ color: theme.secondaryText }}
                        >
                          {skillSentence}
                        </p>
                      );
                    })}
                  </div>
                </Fade>
                <Fade right duration={1500}>
                  <div className="project-build-btn">
                    <Button
                      text="🎮 Download build"
                      newTab={true}
                      href={skill.buildLink}
                      theme={theme}
                    />
                  </div>
                </Fade>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SkillSection;
